import { useState } from "react";
import { announceResources } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { toast } from "sonner";
import { Loader2, Megaphone } from "lucide-react";

export const AnnounceDialog = ({ open, onOpenChange, folder }) => {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!message.trim()) return toast.error("Write a short message first");
    setSending(true);
    try {
      const { data } = await announceResources({ message, folder_id: folder?.id });
      toast.success(`Sent to ${data.recipients} partner${data.recipients === 1 ? "" : "s"}`);
      setMessage("");
      onOpenChange(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="announce-dialog">
        <DialogHeader>
          <DialogTitle>Notify partners</DialogTitle>
          <DialogDescription>
            Every partner rep and manager gets an email and an in-app alert{folder ? ` about "${folder.name}"` : ""}.
          </DialogDescription>
        </DialogHeader>
        <Label>Message</Label>
        <Textarea rows={4} value={message} onChange={(e) => setMessage(e.target.value)}
          placeholder="Our Holiday 2026 slides are live — perfect for Q4 retail and restaurant pitches."
          data-testid="announce-message" />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={send} disabled={sending} data-testid="announce-send">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Megaphone className="h-4 w-4 mr-2" />Send</>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
